import { connect } from 'react-redux'
import component from 'components/Reports'

const mapStateToProps = (state, ownProps) => ({
  orders: state.orders,
  report: ownProps.params.report,
  date: ownProps.params.date
})

export default connect(mapStateToProps)(component)



// WEBPACK FOOTER //
// ./src/routes/Reports/containers/ReportsContainer.js